import type { Language } from "@/Common/Models/Domain/Language";

export const LANG_STORAGE_KEY = "lang";
export const LOCALE_STORAGE_SERVICE = "i18n";

export const getLocaleCacheStorageKey = (locale: Language): string => `locale:${locale}`;
